import {
  CONSULTA_LIQUIDACION_SUCCESS,
  CONSULTA_LIQUIDACION_ERROR,
  CONSULTA_DEBITOS_SUCCESS,
  CONSULTA_DEBITOS_ERROR,
  CONSULTA_DETALLES_SUCCESS,
  CONSULTA_DETALLES_ERROR,
  CONSULTA_RESPONSE_WAIT,
  CONSULTA_RESPONSE_END,
} from '../constants/index';
import { filterEjecuciones, filterResult } from './utils';

export default function consultaDeLiquidacion(state = {}, action) {
  const newState = {};
  switch (action.type) {
    case CONSULTA_LIQUIDACION_SUCCESS:
      newState.consultaLiquidacion = filterEjecuciones(
        action.data?.body?.ejecuciones[0].resultSets,
      );
      newState.isDirect = action.data.isDirect;
      return newState;
    case CONSULTA_LIQUIDACION_ERROR:
      newState.httpErrorCode = action.data;
      newState.consultaLiquidacion = [];
      return newState;
    case CONSULTA_DEBITOS_SUCCESS:
      newState.consultaDebitos = action.data;
      return newState;
    case CONSULTA_DEBITOS_ERROR:
      newState.consultaDebitos = action.data;
      return newState;
    case CONSULTA_DETALLES_SUCCESS:
      newState.consultaDetalles = action.data;
      return newState;
    case CONSULTA_DETALLES_ERROR:
      newState.consultaDetalles = action.data;
      return newState;
    case CONSULTA_RESPONSE_WAIT:
      newState.loading = true;
      return newState;
    case CONSULTA_RESPONSE_END:
      newState.loading = false;
      return newState;
    default:
      return newState;
  }
}
